import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=73f3805d&scoped=true&"
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=73f3805d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f3805d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f3805d')) {
      api.createRecord('73f3805d', component.options)
    } else {
      api.reload('73f3805d', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=73f3805d&scoped=true&", function () {
      api.rerender('73f3805d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/components/CardItem.vue"
export default component.exports